import React from 'react';
import { siteData } from '../data/mock';
import { AnimatedLogo } from './Header';

export const FooterSection = () => {
  const { footer } = siteData;

  return (
    <footer
      style={{
        background: 'var(--bg-primary)',
        borderTop: '1px solid var(--border-subtle)',
        padding: '40px 7.6923%',
      }}
    >
      <div
        className="flex flex-col md:flex-row items-center justify-between gap-4"
        style={{ maxWidth: '1400px', margin: '0 auto' }}
      >
        <div className="flex items-center gap-3">
          <a
            href="#top"
            onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}
          >
            <AnimatedLogo size="default" />
          </a>
          <span
            style={{
              fontSize: '13px',
              color: 'var(--text-muted)',
              fontFamily: "'Inter', sans-serif",
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}
          >
            {footer.brand}
          </span>
        </div>

        <div className="flex items-center gap-6">
          <span
            style={{
              fontSize: '13px',
              color: 'var(--text-muted)',
              fontFamily: "'Inter', sans-serif",
            }}
          >
            {footer.location}
          </span>
          <span
            style={{
              width: '1px',
              height: '16px',
              background: 'rgba(255,255,255,0.15)',
              display: 'inline-block',
            }}
          />
          <span
            style={{
              fontSize: '13px',
              color: 'var(--text-muted)',
              fontFamily: "'Inter', sans-serif",
            }}
          >
            {footer.year}
          </span>
        </div>
      </div>
    </footer>
  );
};
